<template>
  <router-link
    v-if="UserService.user.value"
    to="/profile"
    class="shadow-xs z-10 top-0 flex gap-x-4 sm:gap-x-2.5 items-center flex-start sm:justify-center p-5 bg-primary-100 hover:bg-primary-150 font-medium text-base transition-animation cursor-pointer"
  >
    <img class="w-5 h-5 shrink-0" src="/images/emojis/wave.svg" alt="wave emoji" />
    <p>Welcome back! <span class="font-normal">Choose your snacks to burn.</span></p>
    <svg
      class="w-4 h-4 ml-auto shrink-0 sm:ml-0"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 10"
    >
      <path
        data-v-f6222d11=""
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M1 5h12m0 0L9 1m4 4L9 9"
      ></path>
    </svg>
  </router-link>
</template>

<script setup lang="ts">
import UserService from '@/services/user'
</script>

<style scoped></style>
